<orbit-dialog-header transparent centerTitle>
  <div class="left-addon" left-addon>
    <div class="counter">
      <span class="current-index">{{ selectedMessageIndex() + 1 }}</span>
      <span class="total-index">&nbsp;/ {{ assetsMessages().length }}</span>
    </div>
  </div>
  <div class="right-addon" right-addon>
    <orbit-fa-icon
      role="button"
      tabindex="0"
      (click)="closeDialog()"
      [iconName]="closeIcon"
      class="close-icon" />
  </div>
</orbit-dialog-header>

<div class="dialog-content">
  <div class="preview">
    <orbit-fa-icon [iconName]="leftIcon" (click)="onLeftClick()" class="arrow-left" />
    @switch (selectedMessage()?.kind) {
      @case (messageKindEnum.Image) {
        <img [src]="selectedMessage()?.asset?.downloadUrl" alt="image" class="asset" />
      }

      @case (messageKindEnum.Audio) {
        <audio controls [src]="selectedMessage()?.asset?.downloadUrl" class="asset"></audio>
      }

      @case (messageKindEnum.Video) {
        <video controls autoplay playsinline preload="none" class="asset">
          <source [src]="selectedMessage()?.asset?.downloadUrl" type="video/mp4" />
        </video>
      }
    }
    <orbit-fa-icon [iconName]="rightIcon" (click)="onRightClick()" class="arrow-right" />
  </div>
  <div class="thumbnails">
    @for (message of assetsMessages(); track message.id; let i = $index) {
      @if (message.asset) {
        <div
          class="thumbnail"
          (click)="selectMessage(message)"
          [ngClass]="{ active: selectedMessage()?.id === message.id }"
          [tabindex]="i + 1"
          role="button"
          (keydown.enter)="selectMessage(message)">
          @switch (message.kind) {
            @case (messageKindEnum.Image) {
              <img [src]="message.asset.downloadUrl" alt="image" class="message-image" />
            }

            @case (messageKindEnum.Audio) {
              <orbit-fa-icon class="audio-icon" [iconName]="audioIcon" />
            }

            @case (messageKindEnum.Video) {
              <orbit-fa-icon class="video-icon" [iconName]="videoIcon" />
            }
          }
        </div>
      }
    }
  </div>
</div>
